import React, { FC } from 'react';
import { Typography, Box } from '@mui/material';

import meter from 'packages/novous_web/src/assets/icons/Meter.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import Button from 'packages/novous_web/src/common/components/Button';
import InputField from 'packages/novous_web/src/common/components/InputField';

interface AlertConfig {
  displayName: string;
  enabled: boolean;
  expanded: boolean;
  thresholdValue?: number;
  min?: number;
  criticalEvent?: boolean;
  max?: number;
  label?: string;
  error?: string;
}

interface AlertSettingsGridProps {
  alertConfigState: Record<string, AlertConfig>;
  alertData: any;
  theme: any;
  onToggle: (key: string) => void;
  onExpand: (key: string) => void;
  onCheckCritical?: (key: string, criticalEvent: boolean) => void;
  onInputChange: (key: string, newValue: number) => void;
}

const AlertSettingsGrid: FC<AlertSettingsGridProps> = ({
  alertConfigState,
  alertData,
  theme,
  onToggle,
  onExpand,
  onInputChange,
  onCheckCritical
}) => {
  return (
    <>
      <div className="w-full grid grid-cols-2 gap-4">
        {alertConfigState &&
          Object.entries(alertConfigState).map(([key, config]) => {
            if (key === 'warningAudioLanguage') return null;

            return (
              <div
                key={key}
                className={`flex flex-col gap-2 border border-[#F0EFF8] p-4 rounded-lg ${config.label ? 'cursor-pointer' : ''}`}
                onClick={() => {}}
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2">
                    <img src={meter} alt="Meter" className="w-6 h-6" />
                    <Typography variant="body2" fontSize="16px" fontWeight={500} lineHeight="26px">
                     {alertData[key]?.[0]?.label || config.displayName}
                    </Typography>
                  </div>

                  <div className="flex items-center gap-3">
                    {typeof config.criticalEvent !== 'undefined' && (
                      <label className="flex items-center gap-1 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={config.criticalEvent}
                          onChange={() => onCheckCritical && onCheckCritical(key, !config.criticalEvent)}
                        />
                        <Typography variant="caption" color='error'>Critical</Typography>
                      </label>
                    )}

                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={config.enabled}
                        onChange={() => onToggle(key)}
                      />
                      <Box
                        className="w-12 h-6 flex items-center rounded-full transition-colors duration-300 ease-in-out"
                        sx={{
                          backgroundColor: config.enabled
                            ? theme.palette.primary.main
                            : theme.palette.secondary.main,
                        }}
                      >
                        <div
                          className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${config.enabled ? 'translate-x-6' : 'translate-x-1'
                            }`}
                        />
                      </Box>
                    </label>
                  </div>

                </div>

                {config.expanded && config.enabled && typeof config.label === 'string' && (
                  <div
                    className="flex flex-col gap-2 mt-4"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <InputField
                      label={config.label}
                      value={config.thresholdValue ?? 0}
                      onChange={(e) =>
                        onInputChange(key, Number(e.target.value))
                      }
                      type="number"
                      min={config.min}
                      max={config.max}
                    />
                    {config.error && (
                      <Typography variant="caption" color="error">
                        {config.error}
                      </Typography>
                    )}
                  </div>
                )}
              </div>
            );
          })}
      </div>


    </>
  );
};

export default AlertSettingsGrid;
